import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HistoryLogComponent} from './history-log.component';


export const historyLogRoutes: Routes = [
  {
    path: 'historyLog',
    component: HistoryLogComponent,
    data: {
      'expectedRoles': ['Admin','IT']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(historyLogRoutes)],
  exports: [RouterModule]
})
export class HistoryLogRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log-routing.module.ts